import { CommonService } from "../../../../../services/CommonService";
import JobRole from "../../components/JobRole";
import { order } from "../SmartSearchParammeter";

export default async function JobRoleSearchConfig(key) {
  let jobRoles = await CommonService.getAllJobRoles();
  return {
    description: "Job Role",
    id: "jobRoles",
    initial: [],
    type: order.second,
    handleValues: (searchObject) => {
      searchObject.jobRoles = searchObject.jobRoles.map((j) => j.id);
    },
    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <JobRole
          searchObject={searchObject}
          setSearchObject={setSearchObject}
          t={t}
        />
      </div>
    ),
    operation: ["Must"],
    list: jobRoles.map((j) => j.description.replace(/,/g, "#")),

    handler: function (searchObj, value) {
      searchObj["jobRoles"] = jobRoles.filter(
        (j) => value[0] == j.description.replace(/#/g, ",").trim()
      );
    }
  };
}
